module.exports = __webpack_public_path__ + "img/tema-3-3.ad4b08f9.svg";